import { Dispatch, useCallback } from 'react';

import { useValidateCartAwaitable } from '../../../services';
import { CartActions, ECartActions } from '../model';

export const useValidateCart = (dispatch: Dispatch<CartActions>) => {
  const { request } = useValidateCartAwaitable();

  return useCallback(async () => {
    const benefitsResult = await request();

    if (benefitsResult?.data) {
      dispatch({
        actionType: ECartActions.UPDATE_BENEFITS,
        payload: { ...benefitsResult.data },
      });
    }
  }, [dispatch, request]);
};
